import { POSTFORM, POST, GET } from '@/utils/request.ts'

// 闪送员装备认证
export const queryEquipList = (params: object) => {
  return GET({ url: '/v3/label/equip', params })
}
